<template>
  <QuestionnaireBase :form="form" :title="title" :finishFunction="null">
    <template v-slot:default>
      <component :is="show" :key="1" :ref="show" v-model="form"/>
      <component
          v-if="load in $options.components"
          v-show="false"
          :is="load"
          key="load"
          :ref="load"
          v-model="form"
      />
    </template>
  </QuestionnaireBase>
</template>

<script>
import {loadHelpers} from "../../loadHelpers";
import {dateFormat} from "@/mixins/dateFormat";

import QuestionnaireBase from "../../../../components/common/questionnaires/questionnaire";
import PropertyAttorneys from "@/components/common/questionnaires/fieldsets/lpa/property/PropertyAttorneys";
import PropertyCertificateProvider
  from "@/components/common/questionnaires/fieldsets/lpa/property/PropertyCertificateProvider";
import PropertyOptions from "@/components/common/questionnaires/fieldsets/lpa/property/PropertyOptions";

export default {
  name: "LpaSimpleFinancial",
  mixins: [loadHelpers, dateFormat],
  components: {
    QuestionnaireBase,
    PropertyAttorneys,
    PropertyCertificateProvider,
    PropertyOptions
  },
  data() {
    return {
      name: 'LpaFinancialInstructions',
      title: 'LPA Financial Instructions',
      url: 'estate_planning_lpa',
      order:
          [
            'PropertyAttorneys',
            'PropertyCertificateProvider',
            'PropertyOptions'
          ]
    }
  }
};
</script>
